module.exports = __webpack_public_path__ + "media/images/icons/instagram-35a0245e4f90f05d0084ee11f05fc819.svg";